// entry.client.js
import createApp from './src/app.js';
import { SITE_ORIGIN, BRAND_ASSET_VERSION } from './src/config/site';

const { app, router } = createApp();

router.onReady(() => {
  updateMeta(router.currentRoute);

  router.beforeEach((to, from, next) => {
    updateMeta(to);
    next();
  });

  const mountEl =
    document.querySelector('#app[data-server-rendered="true"]') || document.getElementById('app');
  if (!mountEl) {
    console.error('[client] 找不到 #app 挂载点，页面无法渲染');
    return;
  }
  app.$mount(mountEl);
});

function updateMeta(route) {
  const meta = route.meta || {};
  const defaultDescript = `Independent guides for GB WhatsApp Pro APK: features, install steps, updates, safety, and troubleshooting for Android users.`
  const defaultKeyword = 'gb whatsapp pro apk, gb whatsapp pro download, gb whatsapp pro android'
  document.title = meta.title || 'GB WhatsApp Pro APK Download for Android';
  const defaultCanonical = `${SITE_ORIGIN}/`;

  

  setMetaTag('description', meta.description || defaultDescript);
  setMetaTag('og:description', meta.description || defaultDescript);
  setMetaTag('keywords', meta.keywords || defaultKeyword);
  setLinkTag('canonical', meta.link?.find(link => link.rel === 'canonical')?.href || defaultCanonical);

  setLinkTag('icon', `/favicon.ico?v=${BRAND_ASSET_VERSION}`);
  setMetaProperty('og:image', `${SITE_ORIGIN}/gbwa-logo.webp`);
  setMetaTag('image', `${SITE_ORIGIN}/gbwa-logo.webp`);
  setMetaTag('twitter:image', `${SITE_ORIGIN}/gbwa-logo.webp`);

  if (meta.noindex) {
    setMetaTag('robots', 'noindex');
  } else {
    // 如果不是 noindex 页面，确保 robots 标签是默认的
    setMetaTag('robots', 'index,follow');
  }
}

function setMetaTag(name, content) {
  let element = document.querySelector(`meta[name="${name}"]`);
  if (element) {
    element.setAttribute('content', content);
  } else {
    element = document.createElement('meta');
    element.setAttribute('name', name);
    element.setAttribute('content', content);
    document.head.appendChild(element);
  }
}

function setLinkTag(rel, href) {
  let element = document.querySelector(`link[rel="${rel}"]`);
  if (element) {
    element.setAttribute('href', href);
  } else {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    element.setAttribute('href', href);
    document.head.appendChild(element);
  }
}

function setMetaProperty(property, content) {
  let element = document.querySelector(`meta[property="${property}"]`);
  if (element) {
    element.setAttribute('content', content);
  } else {
    element = document.createElement('meta');
    element.setAttribute('property', property);
    element.setAttribute('content', content);
    document.head.appendChild(element);
  }
}
